import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconCard = ({ t, className, height, width }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath="url(#clip0_5317_57470)">
      <rect width="200" height="200" fill="white"/>
      <g clipPath="url(#clip1_5317_57470)">
        <path d="M174.5 134.122C174.5 146.873 164.117 157.256 151.367 157.256H25.5V65.6333C25.5 52.8826 35.8826 42.5 48.6333 42.5H174.5V134.122V134.122Z" fill="white"/>
        <path d="M133.516 110.624H143.079C143.352 110.624 143.99 110.533 144.263 110.533C146.084 110.169 147.633 108.529 147.633 106.252C147.633 104.067 146.084 102.427 144.263 101.972C143.99 101.881 143.443 101.881 143.079 101.881H133.516V110.624Z" fill="url(#paint0_linear_5317_57470)"/>
        <path d="M141.986 50.2412C132.878 50.2412 125.41 57.6184 125.41 66.817V84.0303H148.817C149.363 84.0303 150.001 84.0303 150.456 84.1214C155.738 84.3946 159.655 87.1269 159.655 91.8629C159.655 95.597 157.013 98.7846 152.095 99.4221V99.6043C157.469 99.9686 161.567 102.974 161.567 107.619C161.567 112.628 157.013 115.907 151.002 115.907H125.319V149.605H149.636C158.744 149.605 166.212 142.228 166.212 133.029V50.2412H141.986V50.2412Z" fill="url(#paint1_linear_5317_57470)"/>
        <path d="M146.449 92.9556C146.449 90.7698 144.9 89.3125 143.079 89.0393C142.897 89.0393 142.441 88.9482 142.168 88.9482H133.516V96.9629H142.168C142.441 96.9629 142.988 96.9629 143.079 96.8718C144.9 96.5986 146.449 95.1414 146.449 92.9556V92.9556Z" fill="url(#paint2_linear_5317_57470)"/>
        <path d="M50.3636 50.2412C41.2561 50.2412 33.7879 57.6184 33.7879 66.817V107.71C38.4327 109.987 43.2597 111.444 48.0868 111.444C53.8245 111.444 56.9211 107.983 56.9211 103.247V83.9393H71.1289V103.156C71.1289 110.624 66.4841 116.727 50.7279 116.727C41.165 116.727 33.6968 114.632 33.6968 114.632V149.514H58.014C67.1216 149.514 74.5898 142.137 74.5898 132.938V50.2412H50.3636V50.2412Z" fill="url(#paint3_linear_5317_57470)"/>
        <path d="M96.1748 50.2412C87.0672 50.2412 79.599 57.6184 79.599 66.817V88.493C83.7885 84.9411 91.0746 82.6642 102.823 83.2106C109.108 83.4839 115.847 85.2143 115.847 85.2143V92.2272C112.477 90.4967 108.47 88.9484 103.279 88.5841C94.3533 87.9466 88.9798 92.3182 88.9798 99.9686C88.9798 107.71 94.3533 112.082 103.279 111.353C108.47 110.989 112.477 109.349 115.847 107.71V114.723C115.847 114.723 109.199 116.453 102.823 116.727C91.0746 117.273 83.7885 114.996 79.599 111.444V149.696H103.916C113.024 149.696 120.492 142.319 120.492 133.12V50.2412H96.1748V50.2412Z" fill="url(#paint4_linear_5317_57470)"/>
      </g>
    </g>
    <defs>
      <linearGradient id="paint0_linear_5317_57470" x1="125.395" y1="106.263" x2="166.322" y2="106.263" gradientUnits="userSpaceOnUse">
        <stop stopColor="#007940"/>
        <stop offset="0.2285" stopColor="#00873F"/>
        <stop offset="0.7433" stopColor="#40A737"/>
        <stop offset="1" stopColor="#5CB531"/>
      </linearGradient>
      <linearGradient id="paint1_linear_5317_57470" x1="125.394" y1="99.8833" x2="166.324" y2="99.8833" gradientUnits="userSpaceOnUse">
        <stop stopColor="#007940"/>
        <stop offset="0.2285" stopColor="#00873F"/>
        <stop offset="0.7433" stopColor="#40A737"/>
        <stop offset="1" stopColor="#5CB531"/>
      </linearGradient>
      <linearGradient id="paint2_linear_5317_57470" x1="125.394" y1="92.9442" x2="166.323" y2="92.9442" gradientUnits="userSpaceOnUse">
        <stop stopColor="#007940"/>
        <stop offset="0.2285" stopColor="#00873F"/>
        <stop offset="0.7433" stopColor="#40A737"/>
        <stop offset="1" stopColor="#5CB531"/>
      </linearGradient>
      <linearGradient id="paint3_linear_5317_57470" x1="33.7686" y1="99.8833" x2="75.3292" y2="99.8833" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1F286F"/>
        <stop offset="0.4751" stopColor="#004E94"/>
        <stop offset="0.8261" stopColor="#0066B1"/>
        <stop offset="1" stopColor="#006FBC"/>
      </linearGradient>
      <linearGradient id="paint4_linear_5317_57470" x1="79.3635" y1="99.8833" x2="119.729" y2="99.8833" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6C2C2F"/>
        <stop offset="0.1735" stopColor="#882730"/>
        <stop offset="0.5731" stopColor="#BE1833"/>
        <stop offset="0.8585" stopColor="#DC0436"/>
        <stop offset="1" stopColor="#E60039"/>
      </linearGradient>
      <clipPath id="clip0_5317_57470">
        <rect width="200" height="200" fill="white"/>
      </clipPath>
      <clipPath id="clip1_5317_57470">
        <rect width="150" height="115.756" fill="white" transform="translate(25 42)"/>
      </clipPath>
    </defs>
  </svg>
)

export default Icon(IconCard)
